import "./brands-public-content-menu.scss";

const $getArrows = () => document.querySelectorAll(".js-arrow-button");
const $getProductsScrollGrid = () => document.querySelector(".js-products-scroll-grid");

const scrollOffset = 50; // detect scroll collision in advance

const handleScroll = ($scrollBox, $arrows) => {
  const { offsetWidth, scrollLeft, scrollWidth } = $scrollBox;
  const [$arrowLeft, $arrowRight] = $arrows;
  const hideLeftArrow = scrollLeft <= scrollOffset;
  const hideRightArrow = scrollWidth - scrollOffset <= offsetWidth + scrollLeft;

  $arrowLeft.classList.toggle("hidden", hideLeftArrow);
  $arrowRight.classList.toggle("hidden", hideRightArrow);
};

export default () => {
  const $scrollBox = $getProductsScrollGrid();
  const $arrows = $getArrows();
  const callback = () => handleScroll($scrollBox, $arrows);
  const options = { passive: true };

  $scrollBox?.addEventListener("scroll", callback, options);
};
